import { gql } from '@apollo/client';

export const CREATE_QUIZ = gql(/*GraphQL*/ `
  mutation CreateQuiz($tag: String!, $userId: ID!) {
  createQuiz(tag: $tag, userId: $userId) {
    id
    userId
    userQuestions {
      questionId
      question{
        id
        prompt
        tag
        explanation
        options {
          desc
          isAnswer
        }
      }
      selectedOption {
        desc
        isAnswer
      }
    }
    isCompleted
    tag
    completedAt
    createdAt
    updatedAt
  }
}`);
